import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Suspense } from 'react';
import { SimpleTreeView, TreeItem } from '@mui/x-tree-view';
import { Typography, useTheme } from '@mui/material';
import 'shared/translate-config/i18n';
import { CheckboxForTree } from 'shared/device.z3k.tree-view-compare/ui/checkbox-for-tree';
export const TreeViewForHeatingZones = (props) => {
    const { t } = useTranslation();
    const { component, newSetter, keyResult, onCheckNewConfig, data, title, nodeId, idSensor, } = props;
    const theme = useTheme();
    const labelForComponent = (setter) => Object.keys(setter.settings)?.map((i) => {
        return (_jsxs(Typography, { variant: "inherit", children: [t(`${data.key}.${i}`), ":", ' ', JSON.stringify(setter.settings[i])] }, i));
    });
    return (_jsx(Suspense, { fallback: "loading", children: component && (_jsx(SimpleTreeView, { multiSelect: !!onCheckNewConfig, defaultExpandedItems: [JSON.stringify(component)], "aria-label": 'Tree setter for name settings', children: _jsx(TreeItem, { itemId: JSON.stringify(component), label: t(`${data.key}.${title}`), children: component.map((setter) => {
                    const heating_zones_Setter = {
                        settings: {
                            heating_zones: { ...setter.settings },
                            heating_circuit: setter.idSensor,
                        },
                        id: setter.id,
                    };
                    const componentForCheck = {
                        setter: heating_zones_Setter,
                        name: setter.name,
                        flag: setter.flag,
                        idSensor: idSensor,
                    };
                    return (_jsx(TreeItem, { itemId: setter.id, sx: {
                            background: setter.flag === 'Добавлен'
                                ? '#e0f2f1'
                                : setter.flag === 'Удален'
                                    ? '#ffcdd2'
                                    : 'f0f0f0',
                            color: setter.flag
                                ? '#101010'
                                : theme.palette.text.primary,
                        }, label: setter.flag && onCheckNewConfig ? (_jsx(CheckboxForTree, { newSetter: newSetter, keyResult: keyResult, setter: heating_zones_Setter, component: componentForCheck, onCheckNewConfig: onCheckNewConfig, data: data, name: nodeId, labelForComponent: _jsxs(Typography, { variant: "inherit", children: [`${setter.name}+${setter.idSensor}`, setter.flag && setter.flag] }) })) : (_jsxs(Typography, { variant: "inherit", children: [`${setter.name}+${setter.idSensor}`, setter.flag && setter.flag] })), children: !setter.flag && (_jsx(TreeItem, { itemId: `${setter.settings.heating_circuit}`, label: onCheckNewConfig ? (_jsx(CheckboxForTree, { newSetter: newSetter, keyResult: keyResult, setter: heating_zones_Setter, onCheckNewConfig: onCheckNewConfig, component: componentForCheck, data: data, name: nodeId, labelForComponent: labelForComponent(setter) })) : (labelForComponent(setter)) }, setter.id)) }, setter.id));
                }) }) })) }));
};
